(ns common.schema.entities.ai-document-generation.permissions
  (:require [common.roles :as roles]))

(defn read-permissions?
  [{:keys [account entity role]}]
  (or (roles/admin? role)
      (= (:db/id account)
         (:db/id (:ai-document-generation/requested-by entity)))))

(defn disable-permissions?
  [{:keys [tr]}]
  (tr :not-allowed))
